import React, { useContext, useState } from 'react'
import { HideLoder, LogInSchoolID, LogInUserID, ShowLoder } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { ApiGetCDNData, ApiPostCall } from '../../JS/Connector';
import { useNavigate } from 'react-router-dom';
import { AuditContext } from '.';
import { UserContext } from '../../App';
import SectionComponent from './Sectioncomponent';
import UnscannedDevice from './UnscannedDevice';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';
export default function FinalAudit() {
    const { dynamic_brand_text } = useConfig();
    const { FinalScanned, Auditnum, showWelcomeAuditDiv, FinalUnScanned } = useContext(AuditContext);
    const navigate = useNavigate();
    const { UserData } = useContext(UserContext);
    const [Visibility, setVisibility] = useState({});
    const [deviceOptions, setDeviceOptions] = useState(FinalScanned.map(() => ({
        newDevice: 0,
        mismatch: 0,
        insystemWithoutBuilding: 0,
        insystemWithoutRoom: 0
    })));
    const [Loading, setLoading] = useState(false);
    const [Alerts, setAlerts] = useState('');
    const StateData = useSelector((state) => state.authData);
    async function downloadReports(flag) {
        setLoading(true);
        var FinalArray = [];
        FinalScanned.map((item, index) => {
            var vJson = {};
            vJson['scannedBuildingId'] = item.scanned_building_id;
            vJson['scannedBuildingName'] = item.scanned_building_name;
            vJson['scannedRoomId'] = item.scanned_room_id;
            vJson['scannedRoomName'] = item.scanned_room_name;
            vJson['newDeviceOption'] = deviceOptions[index].newDevice;
            vJson['newDevice'] = item.new_device;
            vJson['mismatchDeviceOption'] = deviceOptions[index].mismatch;
            vJson['mismatch'] = item.mismatch;
            vJson['insystemWithoutBuilding'] = item.insystem_without_building;
            vJson['insystemWithoutBuildingOption'] = deviceOptions[index].insystemWithoutBuilding;
            vJson['insystemWithoutRoom'] = item.insystem_without_room;
            vJson['insystemWithoutRoomOption'] = deviceOptions[index].insystemWithoutRoom;
            vJson['correctlyFound'] = item.correctly_found;
            vJson['auditNumber'] = item.auditNumber;
            FinalArray.push(vJson);
        })
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            userId: LogInUserID,
            agreementFlag: showWelcomeAuditDiv,
            auditNumber: Auditnum,
            username: UserData.UserName,
            status: flag == 1 ? 2 : 3,
            finalData: FinalArray,
            unscannedData: FinalUnScanned
        });
        if (flag == 1) {
            await ApiPostCall("/audit/report/download", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    if (responseRs.response == "success") {
                        setLoading(false);
                        ApiGetCDNData("/" + responseRs.pdf_url, StateData?.Schoolnumber).then((blob) => {
                            const url = URL.createObjectURL(blob);
                            window.open(url, '_blank');
                        });
                    }
                    else {
                        setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.response} />);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />);
                        }, 2000);
                    }
                }
            });
        } else {
            await ApiPostCall("/audit/complete", raw).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    setLoading(false);
                    const responseRs = JSON.parse(result);
                    if (responseRs.response == "success") {
                        setLoading(false);
                        ApiGetCDNData("/" + responseRs.pdf_url, StateData?.Schoolnumber).then((blob) => {
                            const url = URL.createObjectURL(blob);
                            window.open(url, '_blank');
                        });
                        navigate('/manage-device');
                    }
                    else {
                        setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.msg} />);
                        setTimeout(() => {
                            setAlerts(<AlertsComp show={false} />);
                        }, 2000);
                    }
                }
            });
        }
    }
    const handleRadioChange = (index, type, value) => {
        setDeviceOptions((prevState) => {
            const newState = [...prevState];
            newState[index][type] = value;
            return newState;
        });
    };
    function handleArrowClick(i) {
        setVisibility((prevState) => ({
            ...prevState,
            [i]: !prevState[i],
        }));
    }
    return (
        <>
            {Alerts}
            {Loading ? <ShowLoder /> : <HideLoder />}
            <div className='row pt-3 px-3'>
                <UnscannedDevice data={FinalUnScanned} />
                {FinalScanned?.map((item, i) => {
                    const isVisible = Visibility[i];
                    return (<div className='col-12 greyBoxShadow my-2' key={i}>
                        <div className='row py-2'>
                            <div className='col-10'>
                                <b className='mb-0'>Audit Report for <b className='schoolColorStatus'>{item.scanned_building_name}</b> {item.scanned_room_id == 0 ? 'Across The' : ','} <b className='schoolColorStatus'>{item.scanned_room_name}</b></b>
                            </div>
                            <div className='col-2 text-end'>
                                <img src="/images/DownRoundArrow.svg" className={`cursor-pointer img-fluid ${isVisible ? 'd-none' : ''}`}
                                    onClick={() => handleArrowClick(i)} />
                                <img src="/images/UpRoundArrow.svg" className={`img-fluid cursor-pointer ${isVisible ? '' : 'd-none'}`}
                                    onClick={() => handleArrowClick(i)} />
                            </div>
                        </div>
                        {isVisible && (
                            <>
                                <hr className='m-0' />
                                <SectionComponent
                                    title={`Scanned Devices Not in ${dynamic_brand_text}`}
                                    data={item.new_device}
                                    scannedYesNoType="newDevice"
                                    handleRadioChange={handleRadioChange}
                                    scanyesno={deviceOptions[i].newDevice}
                                    radiotext={`These devices you scanned weren't found in the system. Would you like to add them now?`}
                                    showyesno={true}
                                    index={i}
                                />
                                <SectionComponent
                                    title="Mismatched Locations"
                                    data={item.mismatch}
                                    scannedYesNoType="mismatch"
                                    handleRadioChange={handleRadioChange}
                                    scanyesno={deviceOptions[i].mismatch}
                                    radiotext={'Scanned devices have location mismatches. Would you like to update their locations in the system?'}
                                    showyesno={true}
                                    index={i}
                                />

                                <SectionComponent
                                    title={`Correctly Scanned ${dynamic_brand_text} Devices`}
                                    data={item.correctly_found}
                                    showyesno={false}
                                    index={i}
                                />
                                <SectionComponent
                                    title={`Scanned Devices In ${dynamic_brand_text} Without Building`}
                                    data={item.insystem_without_building}
                                    scannedYesNoType="insystemWithoutBuilding"
                                    handleRadioChange={handleRadioChange}
                                    scanyesno={deviceOptions[i].insystemWithoutBuilding}
                                    radiotext={'All devices exist in the system without being assigned to a building. Would you like to add a scanned building?'}
                                    showyesno={true}
                                    index={i}
                                />
                                <SectionComponent
                                    title={`Scanned Devices In ${dynamic_brand_text} Without Room`}
                                    data={item.insystem_without_room}
                                    scannedYesNoType="insystemWithoutRoom"
                                    handleRadioChange={handleRadioChange}
                                    scanyesno={deviceOptions[i].insystemWithoutRoom}
                                    radiotext={'All devices exist in the system without being assigned to a room. Would you like to add a scanned room?'}
                                    showyesno={true}
                                    index={i}
                                />
                            </>
                        )}
                    </div>);
                })}
            </div>
            <div className='col-12 text-center pt-3'>
                <label className='redText'>Before Execute & downloading the reports, please verify your selection and confirm any changes you want to make.</label>
                <br />
                <button className='SaveBtn mx-2 mt-3' onClick={(e) => downloadReports(1)}>Download Report</button>
                <button className='SaveBtn mx-2 mt-3' onClick={(e) => downloadReports(2)}>Download Report & Execute</button>
            </div>
        </>
    )
}
